export default "__VITE_ASSET__BYjssflH__"